<template>
  <v-dialog
    v-model="handleOpen"
    scrollable
    :width="width"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ dialogTitle }}</span>
      </v-card-title>
      <v-card-text ref="scrollableDialogView" :id="scrollId">
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="handleOpen = false"
        >
          關閉 Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogTitle: {
      type: [String],
      default() {
        return '查詢';
      },
    },
    value: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default() {
        return '600px';
      },
    },
    scrollId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      handleOpen: false,
    };
  },
  watch: {
    value(val) {
      this.handleOpen = val;
    },
    handleOpen(val) {
      this.$emit('input', val);
      setTimeout(() => {
        const dom = this.$refs.scrollableDialogView;
        dom.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .selectBox {
  display: flex;
  margin: 0.5rem;
  border: thin solid rgba(0, 0, 0, 0.12);

  &__item {
    width: 160px;
    padding: 0.5rem;

    @include pad-width() {
      width: 200px;
    }
  }

  &__item:not(:last-child) {
    width: 80px;
    border-right: thin solid rgba(0, 0, 0, 0.12);

    @include pad-width() {
      width: 100px;
    }
  }
}
.v-btn {
    text-transform: none; // initial; word-break: break-all;
  }

::v-deep .selectBox:hover {
  box-shadow: 2px 2px 1px rgba(251, 150, 110, 0.25);
  background-color: #FB966E;
  color:white;
  cursor: pointer;
}
</style>
